<template>
  <app-logged id="VinculosDetails">
    <v-flex xs12>
      <app-widget class-widget="xs12">
        <div slot="widget-content">
          <v-list-item three-line>
            <v-list-item-content>
              <div
                class="overline mb-4"
                v-text="`vínculos indústria/cliente`"
              />
              <v-list-item-title
                class="headline font-weight-medium mb-1"
                v-text="industria.nome_fantasia"
              />
              <v-list-item-subtitle
                class="font-weight-medium"
                v-text="Message.registro(filtredVinculos.length)"
              />
            </v-list-item-content>
            <v-list-item-action class="d-flex flex-column justify-center">
              <v-btn
                @click="refresh"
                small
                color="success"
              >
                atualizar
                <v-icon
                  right
                  small
                  color="white"
                >
                  cached
                </v-icon>
              </v-btn>
              <v-chip
                v-if="!desligado && vinculos.length"
                label
                @click="desligado = !desligado"
                class="my-2"
                color="grey darken-2"
                outlined
              >
                Exibir clientes desligados
                <v-icon class="ml-1">
                  check_box_outline_blank
                </v-icon>
              </v-chip>
              <v-chip
                v-if="desligado && vinculos.length"
                @click="desligado = !desligado"
                label
                class="my-2"
                color="warning"
                outlined
              >
                <div class="black--text">
                  Exibir clientes desligados
                </div>
                <v-icon class="ml-1">
                  check_box
                </v-icon>
              </v-chip>
            </v-list-item-action>
          </v-list-item>
          <v-simple-table
            dense
            v-if="filtredVinculos.length"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Cliente
                  </th>
                  <th class="text-center">
                    Ativo
                  </th>
                  <th class="text-center">
                    Cadastramento
                  </th>
                  <th class="text-center">
                    Primeira Fase
                  </th>
                  <th class="text-center">
                    Segunda Fase
                  </th>
                  <th class="text-center">
                    Terceira Fase
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in filtredVinculos"
                  :key="index"
                  @click="edit(item.id)"
                >
                  <td>
                    {{ item.cliente_nome }}
                    <v-tooltip
                      right
                      v-if="item.contrato_fim"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          x-small
                          color="warning"
                          v-bind="attrs"
                          v-on="on"
                        >
                          warning
                        </v-icon>
                      </template>
                      <span>Cliente já desligado</span>
                    </v-tooltip>
                  </td>
                  <td class="text-center">
                    <v-icon
                      :color="getDesistenteColor(!item.cadastramento.desistente)"
                      small
                    >
                      {{ getBooleanIcon(!item.cadastramento.desistente) }}
                    </v-icon>
                  </td>
                  <td class="text-center">
                    <v-icon
                      :color="getBooleanColor(item.cadastramento.completo)"
                      small
                    >
                      {{ getBooleanIcon(item.cadastramento.completo) }}
                    </v-icon>
                  </td>
                  <td class="text-center">
                    <v-icon
                      :color="getBooleanColor(item.primeiraFase.completo)"
                      small
                    >
                      {{ getBooleanIcon(item.primeiraFase.completo) }}
                    </v-icon>
                  </td>
                  <td class="text-center">
                    <v-icon
                      :color="getBooleanColor(item.segundaFase.completo)"
                      small
                    >
                      {{ getBooleanIcon(item.segundaFase.completo) }}
                    </v-icon>
                  </td>
                  <td class="text-center">
                    <v-icon
                      :color="getBooleanColor(item.terceiraFase.completo)"
                      small
                    >
                      {{ getBooleanIcon(item.terceiraFase.completo) }}
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-card-text
            class="d-flex flex-column align-center"
            v-if="filtredVinculos.length === 0"
          >
            <v-row>
              <span>Nenhum cliente foi vinculado nesta indústria.</span>
            </v-row>
          </v-card-text>
        </div>
      </app-widget>
    </v-flex>
  </app-logged>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import Message from '@/plugins/message'
export default {
  name: 'VinculosDetails',
  components: {
    AppWidget,
    AppLogged
  },
  data () {
    return {
      Message,
      loading: false
    }
  },
  computed: {
    ...mapGetters(['vinculos', 'industria']),
    filtredVinculos () {
      return (this.desligado) ? this.vinculos : this.vinculos.filter(item => !item.contrato_fim)
    },
    desligado: {
      get () {
        return this.$store.getters.desligado
      },
      set (val) {
        return this.$store.commit('setDesligado', val)
      }
    }
  },
  methods: {
    ...mapActions(['postRefreshVinculos']),
    getBooleanIcon (value) {
      return value ? 'check_circle' : 'remove_circle'
    },
    getBooleanColor (value) {
      return value ? 'success' : 'error'
    },
    getDesistenteColor (value) {
      return value ? 'info' : 'grey'
    },
    async refresh () {
      await this.postRefreshVinculos({
        industria: Number(this.industria.id),
        desligado: this.desligado
      })
      return this.$router.go(0)
    },
    edit (id) {
      this.$router.push({
        name: 'controle-cadastramento-update',
        params: {
          id: Number(id),
          industria: Number(this.$route.params.id)
        }
      })
    }
  }
}
</script>
